let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d1nBm")).then(() => parcelRequire('8JxCM'));